import { useState } from 'react';

export default function Banned() {
  const [appealText, setAppealText] = useState('');
  const [submitted, setSubmitted] = useState(false);

  return (
    <div className="w-full max-w-lg mx-auto">
      <div className="bg-white rounded-2xl border border-gray-100 shadow-soft p-6 md:p-10 text-center">
        <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-5">
          <i className="ri-forbid-line text-red-500 text-2xl" />
        </div>
        <h1 className="text-xl md:text-2xl font-bold text-deep-navy-500 mb-3">
          Hesabınız kalıcı olarak kapatıldı
        </h1>
        <p className="text-sm text-gray-500 leading-relaxed mb-8 max-w-sm mx-auto">
          Platform kurallarının ihlali nedeniyle hesabınız kapatılmıştır. Bu karar admin ekibimiz tarafından incelenerek verilmiştir.
        </p>

        {!submitted ? (
          <>
            <div className="mb-6 text-left">
              <label className="block text-sm font-medium text-deep-navy-400 mb-2">İtiraz Talebi</label>
              <textarea
                value={appealText}
                onChange={(e) => setAppealText(e.target.value)}
                placeholder="Karara itiraz nedenlerinizi açıklayın..."
                rows={4}
                maxLength={500}
                className="w-full px-4 py-3 rounded-xl border border-gray-200 text-sm text-deep-navy-500 placeholder:text-gray-300 focus:outline-none focus:border-dark-teal-300 transition-colors resize-none"
              />
              <p className="text-xs text-gray-400 mt-1 text-right">{appealText.length}/500</p>
            </div>

            <button
              onClick={() => setSubmitted(true)}
              className="w-full py-3.5 rounded-full text-sm font-semibold text-white bg-dark-teal-500 hover:bg-dark-teal-600 transition-colors cursor-pointer"
            >
              İtiraz Talebi Oluştur
            </button>
          </>
        ) : (
          <div className="p-4 rounded-xl bg-dark-teal-50 border border-dark-teal-200">
            <i className="ri-check-line text-dark-teal-500 text-xl mb-2 block" />
            <p className="text-sm font-semibold text-dark-teal-700 mb-1">İtiraz talebiniz alındı</p>
            <p className="text-xs text-dark-teal-600 leading-relaxed">
              Talebiniz admin ekibine iletilmiştir. En kısa sürede size dönüş yapılacaktır.
            </p>
          </div>
        )}

        <p className="text-xs text-gray-400 mt-6">
          İtiraz talepleri 24-48 saat içinde değerlendirilir.
        </p>
      </div>
    </div>
  );
}